import { ROLES } from 'src/lib/consts';

import { Label } from '../label';

import type { LabelProps } from '../label';

export const mapRoleToLabel = (role: string) => {
  switch (role) {
    case ROLES.SUPER_ADMIN:
      return 'Super Admin';
    case ROLES.MANAGER:
      return 'Manager';
    case ROLES.INSIGHTS:
      return 'Insights';
    default:
      return 'User';
  }
};

export const mapRoleToStatus = (role: string) => {
  switch (role) {
    case ROLES.SUPER_ADMIN:
      return 'error';
    case ROLES.MANAGER:
      return 'info';
    default:
      return 'warning';
  }
};

export function RoleLabel({ role, ...rest }: { role: string } & LabelProps) {
  return (
    <Label variant="soft" color={mapRoleToStatus(role)} {...rest}>
      {mapRoleToLabel(role)}
    </Label>
  );
}
